import LogoLight from './logo-light';
export interface AppLogoProps {
  appName?: string;
}

export const AppLogoComponent = ({ appName }: AppLogoProps) => {
  return (
    <>
      <LogoLight />
      {appName && <span className="ps-3">{appName}</span>}
    </>
  );
};
